"use strict";

const angular = require("angular");

angular
    .module("Agnes")
    .constant("DefaultLanguage", __AGNES__.lang.current)
    .constant("AvailableLanguages", __AGNES__.lang.available)
    .constant("WellUrl", "well.toyota.tcz")


    // Configuration
    .config([
        "$sceDelegateProvider", "WellUrl",
        function ($sceDelegateProvider, wellUrl) {
            $sceDelegateProvider.resourceUrlWhitelist([
                "self",
                window.location.protocol + "//" + wellUrl + "/**"
            ]);
        }
    ]);
